// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__plip3","right":"styles_right__3KHBD"};